export default __webpack_public_path__ + "static/media/trash_blue.aa02357a.svg";